export const getTitleFromDescription = (description: string) => {
  // Create a temporary DOM element to parse HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = description;

  // Look for headings in order of priority (h1 is highest)
  const headings = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

  for (const headingTag of headings) {
    const heading = tempDiv.querySelector(headingTag);
    if (heading && heading.textContent) {
      return heading.textContent.trim();
    }
  }

  return '';
};
